import { InternalAxiosRequestConfig } from 'axios';
import { enqueueSnackbar } from 'notistack';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../../consts/localStorage';

export function addAccessToken(request: InternalAxiosRequestConfig<any>) {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`;
  }
  return request;
}

export async function tryRefreshToken(error: any) {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (refreshToken) {
      try {
        // const response = await AuthService.refreshToken(refreshToken);
        // const newAccessToken = response.data.accessToken;
        // const newRefreshToken = response.data.refreshToken;
        // localStorage.setItem(ACCESS_TOKEN_KEY, newAccessToken);
        // localStorage.setItem(REFRESH_TOKEN_KEY, newRefreshToken);
        // originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        // return axios(originalRequest);
      } catch (axiosError) {
        enqueueSnackbar('Token expired', {
          preventDuplicate: true
        });
        setTimeout(() => {
          localStorage.removeItem(ACCESS_TOKEN_KEY);
          localStorage.removeItem(REFRESH_TOKEN_KEY);
          window.location.href = '/';

        }, 1000);
        return Promise.reject(axiosError);
      }
    }
  }
  return Promise.reject(error);
}
